var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1111(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.44,
    height: 20.357,
    viewBox: "0 0 20.44 20.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-menu-5253352",
    transform: "translate(-79.033 -10.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9834",
    "data-name": "Path 9834",
    d: "M98.553,10.128H88.39a.92.92,0,0,0-.919.918v7.722a.919.919,0,0,0,.919.918H98.553a.92.92,0,0,0,.919-.918V11.046a.92.92,0,0,0-.919-.918Zm0,10.781H92.891a.92.92,0,0,0-.919.919v7.738a.92.92,0,0,0,.919.918h5.662a.92.92,0,0,0,.919-.918V21.827a.92.92,0,0,0-.919-.918Zm-8.437.018H79.95a.919.919,0,0,0-.917.918v7.722a.919.919,0,0,0,.917.918H90.116a.918.918,0,0,0,.917-.918V21.844a.918.918,0,0,0-.917-.918ZM79.95,19.686h5.665a.92.92,0,0,0,.919-.918V11.047a.919.919,0,0,0-.919-.919H79.95a.92.92,0,0,0-.917.918v7.722a.92.92,0,0,0,.917.919Z",
    fill: "#4EB6EE",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1111);
export default __webpack_public_path__ + "static/media/1111.faeafb786fd6e67cd6df41802e0cc198.svg";
export { ForwardRef as ReactComponent };